module.exports = __webpack_public_path__ + "assets/img/3cd85b2f4160636ac2c545731de766d4.svg";